"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
class ReactWrapper {
    constructor() {
        this.hasViewLoaded = false;
        /**
         * Creates a Navigation function that can be passed through to react
         */
        this.NavigateTo = (link, options) => {
            this.router.navigateByUrl(link);
        };
    }
    /**
     * Set the root ID for the react component based on the element name
     */
    get rootId() {
        return `${this.elemRef.nativeElement.tagName.toLowerCase()}-root`;
    }
    /**
     * If anything has been changed, then re-render the component
     */
    ngOnChanges() {
        this.renderComponent();
    }
    /**
     * When the angular view has been initialised render the react component
     */
    ngAfterViewInit() {
        this.hasViewLoaded = true;
        this.renderComponent();
    }
    /**
     * Render the appropriate react component
     */
    renderComponent() {
        if (!this.hasViewLoaded) {
            return;
        }
        react_dom_1.default.render(react_1.default.createElement(this.setComponent(), Object.assign(Object.assign({}, this.setProps()), { Navigate: this.NavigateTo })), document.getElementById(this.rootId));
    }
}
exports.ReactWrapper = ReactWrapper;
//# sourceMappingURL=react-wrapper.js.map